import request from '@/utils/request'

let NcouponApi = {

  /*新优惠券列表*/
  list(data) {
    return request._post('/shop/plus.ncoupon.Index/index', data);
},
/*添加新优惠券*/
add(data) {
    return request._post('/shop/plus.ncoupon.Index/add', data);
},
/*修改新优惠券*/
edit(data) {
    return request._post('/shop/plus.ncoupon.Index/edit', data);
},
/*删除新优惠券*/
del(data) {
    return request._post('/shop/plus.ncoupon.Index/del', data);
},
/*新优惠券详情*/
detail(data) {
  return request._post('/shop/plus.ncoupon.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ncoupon.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ncoupon.Setting/getSetting', data, errorback);
    },
}
export default NcouponApi;



// WEBPACK FOOTER //
// ./src/api/ncoupon.js